import { AxiosPromise } from 'axios'
import { ApiService, Audience, Authentication } from '../../common'
import { AvailablePaymentMethodView } from '@one/types'

export class AppPaymentMethodsApi extends ApiService {
  getPaymentStatus(
    orderId: string
  ): AxiosPromise<{ status: any; paymentUrl: string; clientSecret?: string }> {
    return this.get(`/payments/status/${orderId}`, {
      authentication: Authentication.OPTIONAL,
      aud: Audience.APP
    })
  }

  getStripePublishableKey(paymentMethodId: string): AxiosPromise<string> {
    return this.get(
      `/payment-methods/${paymentMethodId}/stripe/publishable-key`,
      {
        authentication: Authentication.OPTIONAL,
        aud: Audience.APP
      }
    )
  }

  getAvailablePaymentMethods(
    clientId: string,
    purchaseNetCost: number
  ): AxiosPromise<AvailablePaymentMethodView[]> {
    return this.get(`/available-payment-methods`, {
      params: { clientId, purchaseNetCost },
      authentication: Authentication.REQUIRED,
      aud: Audience.APP
    })
  }

  getAccountingDocumentPaymentStatus(correlationId: string): AxiosPromise<any> {
    return this.get(`/payments/accounting_documents/status/${correlationId}`, {
      authentication: Authentication.OPTIONAL,
      aud: Audience.APP
    })
  }
}
